/**
 * Eva brand mark — public logo used on login and in-app chrome.
 */
export function EvaLogo({ className = 'h-7', alt = 'eva', ...props }) {
  return (
    <img
      src="/eva-logo.png"
      alt={alt}
      className={className}
      data-testid="eva-logo"
      draggable={false}
      {...props}
    />
  );
}
